import type { Action } from "../../actions/types";

export type StoreState = boolean;

export const initialState = false;

export function reducer(
  state: StoreState = initialState,
  action: Action
): StoreState {
  switch (action.type) {
    case "GET_REWARDS_SUCCESS":
    case "GET_REWARDS_FAILURE":
      return false;

    case "GET_REWARDS_REQUEST":
      return true;

    default:
      return state;
  }
}
